const DEFAULT_DURATION_MS = 150;

export function snapshotPositions(container, excludeEl) {
  const positions = new Map();
  [...container.children].forEach((child) => {
    if (child === excludeEl) return;
    positions.set(child, child.getBoundingClientRect().top);
  });
  return positions;
}

export function computeDeltas(previousPositions, newPositions) {
  const deltas = new Map();
  newPositions.forEach((newTop, child) => {
    const oldTop = previousPositions.get(child);
    if (oldTop === undefined || oldTop === newTop) return;
    deltas.set(child, oldTop - newTop);
  });
  return deltas;
}

export function playFlip(deltas, durationMs = DEFAULT_DURATION_MS) {
  deltas.forEach((delta, child) => {
    child.style.transition = 'none';
    child.style.transform = `translateY(${delta}px)`;
    // Force a reflow so the browser registers the starting transform before
    // we transition away from it — otherwise the two style writes collapse
    // into one and nothing animates.
    child.getBoundingClientRect();
    requestAnimationFrame(() => {
      child.style.transition = `transform ${durationMs}ms ease`;
      child.style.transform = '';
    });
    child.addEventListener(
      'transitionend',
      () => {
        child.style.transition = '';
      },
      { once: true },
    );
  });
}

export function flipAnimate(
  container,
  previousPositions,
  excludeEl,
  durationMs,
) {
  const newPositions = snapshotPositions(container, excludeEl);
  playFlip(computeDeltas(previousPositions, newPositions), durationMs);
  return newPositions;
}
